import {search_filterParams_Api} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import React, {useEffect, useMemo, useState} from 'react'
import {useFilterHandler} from 'views/Discovery/FilterHandler'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {SearchTypes} from 'views/Search/SearchProvider'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import DiscoveryExplorerMenu from './components/DiscoveryExplorerMenu'
import LoadingBlock from "../Loading/LoadingBlock";

const DiscoveryExplorerContext = React.createContext({
  item: {},
})

export const DiscoveryExplorerProvider = ({
  type = SearchTypes.ALL,
  children,
  ...props
}) => {
  const [values, setValues] = useState({
    type: undefined,
    keyword: undefined,
  })

  const { response, isLoading, handleAsyncAction } = useAsyncAction({
    apiInfo: search_filterParams_Api,
  })

  const item = getResponseItem(response)

  const filterMenu = useMemo(
    () => (Boolean(isLoading) ? <LoadingBlock /> : <DiscoveryExplorerMenu />),
    [isLoading]
  )

  useEffect(() => {
    if (type) {
      setFilter({})
      handleAsyncAction({}, bindQueryParam({ type }))
    }
  }, [type])

  const {
    filter,
    filterRow,
    filterRows,
    setFilter = NullAsDefault,
    removeFilter = NullAsDefault,
  } = useFilterHandler({
    item,
  })

  const onChange = (name, value) => {
    setValues({
      ...values,
      [name]: value,
    })
  }

  return (
    <DiscoveryExplorerContext.Provider
      value={{
        ...props,
        item,
        values,
        filter,
        filterRow,
        filterRows,
        filterMenu,
        isLoading,
        onChange,
        setValues,
        setFilter,
        removeFilter,
      }}>
      {children}
    </DiscoveryExplorerContext.Provider>
  )
}

export default DiscoveryExplorerContext
